import React from 'react';

interface IntersectProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const Intersect: React.FC<IntersectProps> = ({ 
  width = 454, 
  height = 38,
  className,
  style 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 454 38" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path 
        d="M452.601 36.6001C390.499 14.06 311.981 0.600098 226.601 0.600098C141.22 0.600098 62.7017 14.06 0.600586 36.6001" 
        stroke="url(#paint0_linear_118_14851)" 
        strokeWidth="1.2" 
        strokeLinecap="round"
      />
      <defs>
        <linearGradient 
          id="paint0_linear_118_14851" 
          x1="0.600586" 
          y1="18.6001" 
          x2="452.601" 
          y2="18.6001" 
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6F0F" stopOpacity={0} />
          <stop offset="0.5" stopColor="#FF6F0F" />
          <stop offset="1" stopColor="#FF6F0F" stopOpacity={0} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Intersect;

